import React from "react";
import * as Heroicons from "react-icons/hi";
import * as AiIcons from "react-icons/ai";
import { NavItems } from "./NavItems";
import { Link } from "react-router-dom";

const Header = (props) => {
  return (
    <header className="header">
      <div className="navbar">
        <Heroicons.HiOutlineMenuAlt2
          className="hamburger"
          onClick={props.showSidebar}
        />
        <Link to="/" className="navbar__title">
          4Dev.<span className="navbar__title red ">tools</span>{" "}
        </Link>
      </div>
      <nav className={props.sidebar ? "navMenu active" : "navMenu"}>
        <ul className="navMenu__items" onClick={props.showSidebar}>
          <li className="navMenu__items--toggle">
            <AiIcons.AiOutlineClose className="hamburger" />
          </li>
          <div className="navItems ">
            {NavItems.map((item, index) => {
              return (
                <li key={index} className={item.cName}>
                  <Link className="navItem__link" to={item.path}>
                    {item.title}
                  </Link>
                </li>
              );
            })}
          </div>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
